export default "__VITE_ASSET__1SYxtaDn__"